import { GENERICS_HTTP_STATUS_CODES_MAPPER, HttpStatusMapper } from '@repo/core'

export const httpStatusErrorCodesMapper: HttpStatusMapper = {
  GENERICS: GENERICS_HTTP_STATUS_CODES_MAPPER,
}
